import CryptoJS from 'crypto-js'
import store from 'store'
import Langauge from "../i18n/Language";
const t = Langauge;

// import AppBridge from "./appBridge";
// import { History } from '@shopify/app-bridge/actions';

const AesKey = '4f3d5e90d5a6fbf5'; // AES 秘钥
const AesVi = '0fd09fa03ec122f7'; // AES 秘钥偏移量

//pagespeed 检测
export const PAGESPEED_KEY = 'AIzaSyCSYB04QLpReINR3Kxc8FXCHhWEBHWnjIA'

/**
 * CryptoJS加密
 */
let Encrypt = function (data) { //加密

    let encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(AesKey), {
        iv: CryptoJS.enc.Utf8.parse(AesVi),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
}

/**
 * CryptoJS解密
 */
let Decrypt = function (data) {//解密

    let decrypt = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(AesKey), {
        iv: CryptoJS.enc.Utf8.parse(AesVi),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return decrypt.toString(CryptoJS.enc.Utf8);

}

let getSign = function (domain, timeStr) {//解密

    let sign = Encrypt(domain + '-' + timeStr);

    return sign;

}


/**
 * 存储localStorage
 */
let setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    // window.localStorage.setItem(name, content);
    try {
        store.set(name, content);
    } catch (e) {
        console.info(e);
    }
}

/**
 * 获取localStorage
 */
let getStore = name => {
    if (!name) return;
    // return window.localStorage.getItem(name);
    try {
        return store.get(name);
    } catch (e) {
        console.info(e);
    }
}

/**
 * 删除localStorage
 */
let removeStore = name => {
    if (!name) return;
    // window.localStorage.removeItem(name);
    try {
        store.remove(name);
    } catch (e) {
        console.info(e);
    }
}

// 路由监听
// let routeListen = (listenUrl) => {
//     // 多层级菜单
//     const seoAnalytics = '/keywordRearch'; // SEO 分析
//     const speedOpt = '/speedOpt'; // 速度优化
//     const searchApp = '/searchAppearance'; // 搜索表现
//     const backLinks = '/backlinks';   // 外链
//     const Dashboard = '/dashboard'; // 首页
//     // 匹配
//     let urlFormat = Dashboard;
//     if(listenUrl.includes(Dashboard)) {
//         urlFormat = Dashboard;
//     } else if(listenUrl === seoAnalytics) {
//         urlFormat = seoAnalytics;
//     } else if(listenUrl === speedOpt) {
//         urlFormat = speedOpt;
//     } else if(listenUrl === searchApp) {
//         urlFormat = searchApp;
//     } else if(listenUrl === backLinks) {
//         urlFormat = backLinks;
//     } else if(listenUrl.includes(`${Dashboard}/recent-improvements`)) {
//         urlFormat = `${Dashboard}/recent-improvements`;
//     } else if(listenUrl.includes(`${Dashboard}/integration`)) {
//         urlFormat = `${Dashboard}/integration`;
//     } else if(listenUrl.includes(`${Dashboard}/Feedback`)) {
//         urlFormat = `${Dashboard}/Feedback`;
//     }  else if(listenUrl.includes('/on-page-seo') || listenUrl.includes('/on-page-seo/generate-blog')) {
//         urlFormat = '/on-page-seo'
//     } else if(listenUrl.includes('/on-page-seo/detail')) {
//         urlFormat = '/on-page-seo/detail'
//     } else if(listenUrl.includes(`/website-check`)) {
//         urlFormat = `/website-check`;
//     } else if(listenUrl.includes(`${seoAnalytics}/my-website-keywords`)) {
//         urlFormat = `${seoAnalytics}/my-website-keywords`;
//     } else if(listenUrl.includes(`${seoAnalytics}/keywords-search`)) {
//         urlFormat = `${seoAnalytics}/keywords-search`;
//     } else if(listenUrl.includes(`${seoAnalytics}/keywords-monitor`) || listenUrl.includes(`${seoAnalytics}/keywords-research/Competitor-keywords-detail`)) {
//         urlFormat = `${seoAnalytics}/keywords-monitor`;
//     } else if(listenUrl.includes(`${seoAnalytics}/keywords-gap`)) {
//         urlFormat = `${seoAnalytics}/keywords-gap`;
//     } else if(listenUrl.includes(`${seoAnalytics}/keywords-list`)) {
//         urlFormat = `${seoAnalytics}/keywords-list`;
//     } else if(listenUrl.includes(`${speedOpt}/PageSpeed/index`) || listenUrl.includes(`${speedOpt}/PageSpeed/settings`) || listenUrl.includes(`${speedOpt}/PageSpeed/details`) || listenUrl.includes(`${speedOpt}/PageSpeed/setting`)) {
//         urlFormat = `${speedOpt}/PageSpeed/index`;
//     } else if(listenUrl.includes(`${speedOpt}/site-speedup`)) {
//       urlFormat = `${speedOpt}/site-speedup`;
//     } else if(listenUrl.includes(`${speedOpt}/seo-ant-amp`)) {
//         urlFormat = `${speedOpt}/seo-ant-amp`;
//     } else if(listenUrl.includes(`${speedOpt}/instant-page/index`)) {
//         urlFormat = `${speedOpt}/instant-page/index`;
//     } else if(listenUrl.includes(`${searchApp}/bulk-edit/manual-bulk-edit`)) {
//         urlFormat = `${searchApp}/bulk-edit/manual-bulk-edit`;
//     } else if(listenUrl.includes(`${searchApp}/structured-data/index`)) {
//         urlFormat = `${searchApp}/structured-data/index`;
//     } else if(listenUrl.includes(`${searchApp}/local-business/index`)) {
//         urlFormat = `${searchApp}/local-business/index`;
//     } else if(listenUrl.includes(`${searchApp}/instant-index`)) {
//         urlFormat = `${searchApp}/instant-index`;
//     } else if(listenUrl.includes(`${searchApp}/GoogleSearchConsoleV2/index`)) {
//         urlFormat = `${searchApp}/GoogleSearchConsoleV2/index`;
//     } else if(listenUrl.includes(`${backLinks}/broken-link/view-errors`) || listenUrl.includes(`${backLinks}/broken-link/manage-redirects`) || listenUrl.includes(`${backLinks}/broken-link/ignore-page`)) {
//         urlFormat = `${backLinks}/broken-link/view-errors`;
//     } else if(listenUrl.includes(`${backLinks}/backlink-audit`)) {
//         urlFormat = `${backLinks}/backlink-audit`;
//     } else if(listenUrl.includes(`${backLinks}/exchange-backlink/index`)) {
//         urlFormat = `${backLinks}/exchange-backlink/index`;
//     } else if(listenUrl.includes(`${backLinks}/html-sitemap/index`)) {
//         urlFormat = `${backLinks}/html-sitemap/index`;
//     } else if(listenUrl.includes('/admin/Keywords-Library')) {
//         urlFormat = '/admin/Keywords-Library'
//     } else if(listenUrl.includes('/admin/seo-expert-services')) {
//         urlFormat = '/admin/seo-expert-services'
//     } else if(listenUrl.includes('/admin/function-integration')) {
//         urlFormat = '/admin/function-integration'
//     } else if(listenUrl.includes('/admin/instuction-manual/index')) {
//         urlFormat = '/admin/instuction-manual/index'
//     } else if(listenUrl.includes('/plan')) {
//         urlFormat = '/plan'
//     } else if(listenUrl.includes('/settings')) {
//         urlFormat = '/settings'
//     } else if(listenUrl.includes('/reports')) {
//         urlFormat = '/reports'
//     } else {    
//         urlFormat = Dashboard;
//     }

//     const history = AppBridge.app ? History.create(AppBridge.app) : undefined
//     if(history !== undefined) {
//         history.dispatch(History.Action.PUSH, urlFormat)
//     }
// }

// 路由跳转
let routeJump = (_this, to, state = undefined, query = undefined) => {
    let curUrl = window.location.pathname;
    if (to === curUrl) {
        return false
    } else {
        let params = {
            pathname: to,
        }
        if (state !== undefined) {
            params['state'] = state
        }
        if (query !== undefined) {
            params['query'] = query
        }
        _this.props.history.push(params)
    }
}

// 复制文本
let CopyText = async (text = '') => {
    // // 动态创建 textarea 标签
    // const textarea = document.createElement('textarea');
    // // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
    // textarea.readOnly = 'readonly';
    // textarea.style.position = 'absolute';
    // textarea.style.left = '-9999px';
    // // 将要 copy 的值赋给 textarea 标签的 value 属性
    // textarea.value = text;
    // // 将 textarea 插入到 body 中
    // document.body.appendChild(textarea);
    // // 选中值并复制
    // textarea.select();
    // const result = document.execCommand('Copy');
    // if (textarea) {
    //     document.body.removeChild(textarea);
    // }
    // return result;
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (e) {
            console.warn('Clipboard API Error:', e);
        }
    }

    // Fallback：兼容旧浏览器（非安全上下文、非 https）
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.readOnly = true;
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
}

// 首节流
let throttleStart = (func, delay) => {
    let lastCallTime = 0;
    return function () {
        const now = new Date().getTime();
        if (now - lastCallTime >= delay) {
            func.apply(this, arguments);
            lastCallTime = now;
        }
    };
}

// 尾节流
let throttleEnd = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        if (!timer) {
            timer = setTimeout(() => {
                fn.apply(context, args);
                timer = null;
            }, delay);
        }
    }
}

// 防抖
const debounceDIY = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
};
// 重设监听方法
const setupResizeObserver = () => {
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback) {
            callback = debounceDIY(callback, 16);
            super(callback);
        }
    };
};

// 时间格式化
const timeFormat = (timestamp, split = '-', showHMS = true) => {
    // 创建一个 Date 对象
    let date = new Date(timestamp * 1000); // 时间戳是以秒为单位的，所以乘以1000转换为毫秒
    // 提取年、月、日
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 注意月份从0开始，需要加1
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    // 格式化为指定格式
    let formattedDate = year + split + (month < 10 ? '0' : '') + month + split + (day < 10 ? '0' : '') + day;
    let formattedTime = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    return showHMS ? formattedDate + ' ' + formattedTime : formattedDate;
}

// 美式时间格式化
const formatUSATime = (timestamp) => {
    // 创建一个新的 Date 对象，传入时间戳（秒为单位）
    let date = new Date(timestamp * 1000);
    // 定义月份名称
    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // 提取年、月、日、小时、分钟、上午/下午
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    // 组合成指定格式的字符串
    let formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + year;
    return formattedDate;
}

// // 动态添加CSS
// let addCSSRule = (selector, rules, index) => {
//     var styleSheet = document.styleSheets[0];
//     if (styleSheet.insertRule) {
//         styleSheet.insertRule(selector + "{" + rules + "}", index);
//     } else if (styleSheet.addRule) {
//         styleSheet.addRule(selector, rules, index);
//     }
// }

// // 动态删除CSS
// let removeCSSRule = (selector) => {
//     var styleSheet = document.styleSheets[0];
//     if (styleSheet.deleteRule) {
//         for (var i = 0; i < styleSheet.cssRules.length; i++) {
//             if (styleSheet.cssRules[i].selectorText === selector) {
//                 styleSheet.deleteRule(i);
//                 break;
//             }
//         }
//     } else if (styleSheet.removeRule) {
//         for (var i = 0; i < styleSheet.rules.length; i++) {
//             if (styleSheet.rules[i].selectorText === selector) {
//                 styleSheet.removeRule(i);
//                 break;
//             }
//         }
//     }
// }


let utilsFunc = {
    Encrypt,
    Decrypt,
    getSign,
    setStore,
    getStore,
    removeStore,
    // routeListen,
    routeJump,
    CopyText,
    throttleStart,
    throttleEnd,
    debounceDIY,
    setupResizeObserver,
    timeFormat,
    formatUSATime,
    // addCSSRule,
    // removeCSSRule,
};

export default utilsFunc;